angular.module('impactx.system').controller('CatalogValidationCtrl', [
    '$scope',
    'dataGen',
    '$mdDialog',
    'ToolbarService',
    CatalogValidationCtrl
]);

function CatalogValidationCtrl($scope, dataGen, $mdDialog, ToolbarService) {
    var self = this;

    self.showPrompt = function (ev) {
        dataGen.getData({}, {}, '/systemadministration/catalogvalidation/trns').then(function(dialogTrns){
            var confirm = $mdDialog.prompt()
                .title(dialogTrns.trns.title)
                .textContent(dialogTrns.trns.content)
                .placeholder(dialogTrns.trns.placeholder)
                .targetEvent(ev)
                .required(true)
                .theme('system')
                .ok(dialogTrns.trns.ok)
                .cancel(dialogTrns.trns.cancel);

            $mdDialog.show(confirm).then(function (result) {
                if (!isNaN(result) && result > 0) {
                    dataGen.getData($scope, {catId: result}, '/systemadministration/catalogvalidation/view');
                }
                else {
                    self.showPrompt();
                }
            });
        });
    };

    self.showPrompt();
    ToolbarService.setButtons([]);
}